<template>
<v-row align="center" justify="center">
  <v-switch light v-model="$vuetify.theme.dark"></v-switch>
</v-row>
</template>

<script>
export default {
  props: {
    attrs: {
      type: Object,
      default: () => ({})
    }
  },

  data: vm => ({
    initialDark: vm.$vuetify ? vm.$vuetify.theme.dark : false
  }),

  beforeDestroy() {
    if (!this.$vuetify) return;

    this.$vuetify.theme.dark = this.initialDark;
  }
}
</script>